import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const parameters = {
  costInsight: "Cost Insight",
  eventInsight: "Event Insight",
};

export function transposeArray(plans) {
  // console.log("In transposeArray ", plans);
  const keys = Object.keys(plans[0]);
  //console.log("array keys ", keys);

  let newArray = [];

  let rowIndex = 1;
  for (const key of keys) {
    if (key === "id") {
      continue;
    }
    let row = { id: rowIndex++, addons: parameters[key] };
    let col = 0;
    const cols = ["basic", "standard", "premium", "enterprise"];
    for (const plan of plans) {
      if (key === "name") {
        row = { ...row, [cols[col]]: plan[key] };
      } else if (key === "price") {
        row = { ...row, [cols[col]]: "$ " + plan[key] };
      } else {
        row = { ...row, [cols[col]]: +plan[key] };
      }
      col++;
    }
    row = { ...row, [cols[col]]: "Contact us" };
    // console.log("row in transposeArray = ", row);
    newArray.push(row);
    row = {
      id: rowIndex++,
      addons: "Cost Insight",
      basic: 0,
      standard: 0,
      premium: 0,
      enterprise: "Contact us",
    };
    newArray.push(row);
  }
  return newArray;
}

const columns = [
  // { field: "id", headerName: "ID", width: 100,},
  {
    field: "name",
    headerName: "Name",
    width: 200,
  },
  {
    field: "price",
    headerName: (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        Price&nbsp;
        <small style={{ color: "red", fontSize: "smaller" }}>
          (Billed Monthly)
        </small>
      </div>
    ),
    width: 200,
    valueFormatter: (params) => `$${params.value}`,
  },
];

const GlobalAddons = (props) => {
  console.log("Props :: ", props);
  let complianceRows = props.addons["Compliance Add Ons"].map((addOn, index) => {
    return {
      id: index + 1,
      name: addOn.Name,
      price: addOn.Price,
    };
  });
  console.log("GlobalAddons newRows :: ", complianceRows);
  return (
    <div>
      <div
        style={{ justifyContent: "center", display: "flex", flexWrap: "wrap" }}
      >
        <DataGrid
          getRowId={(row) => row.id}
          rows={complianceRows}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              csvOptions: { disableToolbarButton: true },
              printOptions: { disableToolbarButton: true },
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          autoHeight
          rowHeight={40}
        />
      </div>
    </div>
  );
};

export default GlobalAddons;
